interface Location {
  hosted?: string
  storeTitle?: string
  physicalAddress?: string
  level?: string
}

export default function getDescriptiveLocation({
  hosted,
  storeTitle,
  physicalAddress,
  level,
}: Location): string {
  const hasSpecificLocation: boolean =
    Boolean(physicalAddress) || Boolean(level)

  let text = ''

  if (hosted) {
    text = hosted
  } else if (storeTitle) {
    text = storeTitle
  }

  if (text && hasSpecificLocation) {
    text = `${text},`
  }

  if (level) {
    text = `${text} Level ${level}`
  }

  if (physicalAddress) {
    text = `${text} ${physicalAddress}`
  }

  return text.trim()
}
